module.exports = __webpack_public_path__ + "img/nto821gxd7v61 - ノクト・ノクト「Nokt」.6bbedddf.png";